{
  "title": "Holiday mode",
  "settings_link": "Holiday mode",
  "intro": "Take a planned break of {min} to {max} days. Your golfer is just as you left them when you come back.",
  "loading": "Loading your holiday",
  "error": "We couldn't load your holiday. Try again.",
  "retry": "Try again",
  "guest": "Holiday mode is for players with an account. Save your golfer to use it.",
  "book": {
    "heading": "Book a holiday",
    "start": "Starts",
    "start_label": "Start day",
    "length": "How long",
    "length_label": "Number of days",
    "days": "{days, plural, one {# day} other {# days}}",
    "days_left": "{days, plural, one {# holiday day left this season} other {# holiday days left this season}}",
    "summary": "Holiday from {startDate} to {endDate}. Your streak, your training and your golfer's ageing all pause. Nothing is lost.",
    "entries": "{count, plural, one {You will be withdrawn from # event. Your entry fee comes back, and nothing counts against you.} other {You will be withdrawn from # events. Your entry fees come back, and nothing counts against you.}}",
    "in_progress": "{eventName} has already started, so it is played to the end.",
    "yes": "Book holiday",
    "booking": "Booking your holiday",
    "booked": "Holiday booked from {startDate} to {endDate}.",
    "next_from": "Your next holiday can start from {date}.",
    "none_left": "No holiday days are left this season.",
    "too_few_left": "{days, plural, one {Only # holiday day is left this season, and a holiday is at least {min} days.} other {Only # holiday days are left this season, and a holiday is at least {min} days.}}"
  },
  "never_mind": "Never mind",
  "lock": {
    "body": "You are entered in {eventName}, which opens on {windowOpens}. Your holiday can start from {earliestStart}. Pick a later start, or withdraw from {eventName} first.",
    "later": "Pick a later start",
    "event": "Go to {eventName}"
  },
  "card": {
    "running": "On holiday until {lastDay}",
    "booked": "Holiday booked: {startDate} to {endDate}",
    "paused": "Your streak, your training and your golfer's ageing are paused.",
    "waiting": "Your plan carries on as usual until then.",
    "see": "See your holiday"
  },
  "end": {
    "button": "End holiday",
    "take_off": "Take off this holiday",
    "asked": "Your holiday ends at {resetTime}. Your plan starts again then.",
    "taken_off": "Your holiday from {startDate} to {endDate} is taken off."
  },
  "enter": {
    "body": "Entering ends your holiday. Enter?",
    "yes": "Enter"
  },
  "refusal": {
    "bad_length": "A holiday is {min} to {max} days.",
    "start_not_open": "A holiday can start today or up to {days} days ahead.",
    "overlaps_holiday": "These days touch a holiday you have booked. Pick other days.",
    "season_limit": "{days, plural, =0 {No holiday days are left this season.} one {Only # holiday day is left this season.} other {Only # holiday days are left this season.}}",
    "too_soon": "Your next holiday can start from {date}.",
    "too_close_to_next": "{days, plural, one {This ends too close to your holiday from {date}. Leave # day between them.} other {This ends too close to your holiday from {date}. Leave # days between them.}}",
    "other": "That didn't work. Try again."
  }
}
